import { inject, Injectable } from '@angular/core';

import { Actions } from '@ngrx/effects';
import { of, switchMap } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { createEffectFactory } from '@core/ngrx-legacy';

import { OfferTranslationsHttpService } from './offer-translations-http.service';
import { OfferTranslationsActions } from './offer-translations.store';

@Injectable({
  providedIn: 'root',
})
export class OfferTranslationsEffects {
  private readonly offerTranslationsHttpService = inject(OfferTranslationsHttpService);
  private readonly actions$ = inject(Actions);

  public effects = createEffectFactory(OfferTranslationsActions, this.actions$);

  public fetchOne$ = this.effects(OfferTranslationsActions.fetchTranslations, ({ payload }) =>
    this.offerTranslationsHttpService.fetchOne$(payload.offerId, payload.targetLangCode).pipe(
      switchMap(response =>
        of(OfferTranslationsActions.fetchTranslationsSuccess({ payload: response })),
      ),
      catchError(err => of(OfferTranslationsActions.fetchTranslationsFailed({ payload: err }))),
    ),
  );

  public updateOne$ = this.effects(OfferTranslationsActions.updateTranslations, ({ payload }) =>
    this.offerTranslationsHttpService.updateTranslations$(payload.offerId, payload.offer).pipe(
      switchMap(response =>
        of(OfferTranslationsActions.updateTranslationsSuccess({ payload: { ...response } })),
      ),
      catchError(error =>
        of(OfferTranslationsActions.updateTranslationsFailed({ payload: error })),
      ),
    ),
  );
}
